import { useEffect } from 'react';
import tw from 'twin.macro';

import { Layout } from '@insights_module/components/Layout';
import { Header as IntegrationHeader } from '@insights_module/components/integrations/Header';
import { TagsList } from '@insights_module/components/integrations/TagsList';
import { CreateTagModal } from '@insights_module/components/integrations/CreateTagModal';
import { DeleteTagModal } from '@insights_module/components/integrations/DeleteTagModal';
import { INTEGRATION_TYPE } from '@insights_module/constants/integrations';
import { useSegmentCreatorContext } from '@insights_module/context/SegmentCreatorContext';
import { EditTagModal } from '@insights_module/components/integrations/EditTagModal';
import { withTitle } from '@hoc/withTitle';

const ContentWrapper = tw.div`flex flex-col justify-start w-full`;

const _IHMIntegrationPage = (): JSX.Element => {
  const { setQueryType } = useSegmentCreatorContext();

  useEffect(() => {
    setQueryType('audio');
  }, []);

  return (
    <Layout.InsightsPage>
      <ContentWrapper>
        <IntegrationHeader type={INTEGRATION_TYPE.IHM} />
        <TagsList type={INTEGRATION_TYPE.IHM} />
        <CreateTagModal type={INTEGRATION_TYPE.IHM} />
        <DeleteTagModal type={INTEGRATION_TYPE.IHM} />
        <EditTagModal type={INTEGRATION_TYPE.IHM} />
      </ContentWrapper>
    </Layout.InsightsPage>
  );
};

export const IHMIntegrationPage = withTitle(_IHMIntegrationPage, 'insights.integrations.title');
